import PropTypes from 'prop-types';

const StepDoneSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 24}`}
      height={`${height || 24}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill={color}
      />
      <path
        d="M10.5795 15.58C10.3795 15.58 10.1895 15.5 10.0495 15.36L7.21945 12.53C6.92945 12.24 6.92945 11.76 7.21945 11.47C7.50945 11.18 7.98945 11.18 8.27945 11.47L10.5795 13.77L15.7195 8.62998C16.0095 8.33998 16.4895 8.33998 16.7795 8.62998C17.0695 8.91998 17.0695 9.39998 16.7795 9.68998L11.1095 15.36C10.9695 15.5 10.7795 15.58 10.5795 15.58Z"
        fill={color}
      />
    </svg>
  );
};

StepDoneSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default StepDoneSvg;
